var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3531_637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.27761 0.0110207C6.64132 0.2842 6.44089 3.93705 3.84495 3.77575C1.52305 3.63148 1.48469 0.269839 3.72573 0.0110207C3.85325 -0.00367355 4.14975 -0.00367355 4.27761 0.0110207Z",
    fill: "#26445A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.93256 8.27021L1.39623 9.70055C1.09834 10.0696 -0.0130163 10.1317 0.000115403 9.52088L1.63122 4.59932C1.75631 4.34785 2.01618 4.22629 2.29299 4.20592C3.41575 4.1241 4.64357 4.27004 5.77739 4.20725C6.39493 4.28106 6.45852 4.85213 6.62301 5.32235C7.06154 6.57636 7.60063 8.01139 7.94171 9.27743C7.99009 9.45676 8.03951 9.55161 7.95001 9.73595C7.77515 10.096 6.8383 10.0245 6.60677 9.70055L6.07044 8.27021V15.1808C6.07044 15.2389 5.98439 15.465 5.95087 15.5318C5.5469 16.3437 4.17359 16.0261 4.17359 15.1478V10.6019H3.82871V15.1478C3.82871 15.4537 3.57022 15.7987 3.28513 15.9216C2.72046 16.1647 1.93221 15.8047 1.93221 15.1812V8.27054L1.93256 8.27021Z",
    fill: "#26445A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/Child.0277afc06d25b70b138944420e69db51.svg";
export { ForwardRef as ReactComponent };